import _defineProperty from'@babel/runtime/helpers/defineProperty';import {LANG}from'@manulife/mux';import enCA from'./en_CA.js';import frCA from'./fr_CA.js';var _MESSAGES;
var APP_LANGS = {
  EN_CA: LANG.EN_CA,
  FR_CA: LANG.FR_CA
};
var MESSAGES = (_MESSAGES = {}, _defineProperty(_MESSAGES, LANG.EN_CA, enCA), _defineProperty(_MESSAGES, LANG.FR_CA, frCA), _MESSAGES);
var PASSWORD_UPDATE = 'password-update';
var OTC_ERROR = 'otc-error';
var ACTIVATION_ERROR = 'activation-error';
var SIGN_IN_ERROR = 'sign-in-error';export{ACTIVATION_ERROR,APP_LANGS,MESSAGES,OTC_ERROR,PASSWORD_UPDATE,SIGN_IN_ERROR};